import React, { useState } from "react";
import PrivateApi from "../../services/PrivateApiService";
import SplashPage from '../SplashPage';
import { useNavigate, useParams } from "react-router-dom";
import { Card, Col, Container, Row, Button } from "react-bootstrap";
import { BsQuestionLg } from "react-icons/bs";
import { TbCoins, TbFlame, TbTruckDelivery } from "react-icons/tb";
import { SlEnergy } from "react-icons/sl";
import { MdOutlineOilBarrel, MdOutlineSolarPower } from "react-icons/md";
import "react-pdf/dist/esm/Page/TextLayer.css";
import PdfModal from "../../components/shared/PdfModal";
import ElvDetailsCard from "../../components/elvs/ElvDetailsCard";
import { useQuery } from "react-query";
import ElvLeerstandModal from "../../components/elvs/ElvLeerstandModal";
import ElvTeilVorschreibungModal from "../../components/elvs/ElvTeilvorschreibungModal";
import MissingInvoiceModal from "../../components/elvs/ElvMissingInvoiceModal";
import DetailedList from "../../components/shared/DetailedList";
import { FaSwimmingPool } from "react-icons/fa";
import { CgSandClock } from "react-icons/cg";
import { useAuthState } from "../../context/AuthContext";

/**
 * ElvDetailPage
 * 
 * get single Elv details and on click gets Abrechnung, Poolrechnung,
 * Vorschreibung from that Elv.
 * 
 * @returns None
 */
const ElvDetailPage = () => {

    const API = new PrivateApi(); // API calls
    const { user } = useAuthState();
    const { elv_id } = useParams(); // elv id paramater passed
    const navigate = useNavigate(); // navigate
    
    const [pdfFile, setPdfFile] = useState(null);
    const [pdfModal, setPdfModal] = useState(false);
    const [leerstandModal, setLeerstandModal] = useState(false);
    const [teilvorschreibungModal, setTeilvorschreibungModal] = useState(false);
    const [missingInvoiceModal, setMissingInvoiceModal] = useState(false);
    

    // collect data from api
    const { data, error, isLoading } = useQuery(["GET_ELVS_DETAILS_QUERY", elv_id], () => API.get_ElvsDetail(elv_id), { staleTime: Infinity });


    // function to open pdf 
    const readPdf = (file) => {
        setPdfFile(file);
        setPdfModal(true);
    }



    // if data collecting is loading
    if (isLoading) return <SplashPage />

    if (error) return <SplashPage error={"Es ist ein Fehler aufgetreten. Versuche es später erneut"} />

    // GUI
    return (
        <Container className="text-start">
            <Row className="align-items-center">
                <Col xs="12" md="2" xl="1" className="text-center">
                    <div className="border border-2 rounded-circle"
                        style={{ width: "70px", color: "white", paddingLeft: "10px", paddingTop: "10px", paddingRight: "10px", paddingBottom: "10px", display: "inline-block", marginTop: "-10px" }}>
                        {
                            data.elv.x_anlage_id.x_studio_field_3eKe0 === 'Strom' ?
                                <SlEnergy size={40} className={data.elv.x_is_leerstand ? "text-muted" : "text-energo"} />
                                :
                                data.elv.x_anlage_id.x_studio_field_3eKe0 === 'Gas' ?
                                    <TbFlame size={40} className={data.elv.x_is_leerstand ? "text-muted" : "text-cyan"} />
                                    :
                                    data.elv.x_anlage_id.x_studio_field_3eKe0 === 'Oil' ?
                                        <MdOutlineOilBarrel size={40} className={data.elv.x_is_leerstand ? "text-muted" : "text-danger"} />
                                        :
                                        data.elv.x_anlage_id.x_studio_field_3eKe0 === 'Strom-Einspeisung' ?
                                            <MdOutlineSolarPower size={30} className={data.elv.x_is_leerstand ? "text-muted" : "text-warning"} />
                                            :
                                            <BsQuestionLg size={30} className="text-muted" />
                        }
                    </div>
                </Col>
                <Col xs="12" md="7" xl="8">
                    <h3>Energieliefervertrag</h3>
                    <p>
                        {data.elv.x_energieprodukt_id[1]}
                        {
                            data.elv.x_is_leerstand ?
                                <b> : Leerstand</b>
                                :
                                null
                        }
                    </p>
                </Col>
                <Col xs="12" md="3" xl="3" className="text-end">
                    <Button 
                        onClick={() => navigate(`${user.x_is_house_management? `/hw/dashboard/energieliefervertraege/zeitverlauf/${data.elv.x_kunde_id[0]}/` : '/dashboard/zeitverlauf/'}${data.elv.x_anlage_id.x_studio_field_mWMGR}`)}
                        className="btn-energo rounded-pill"><CgSandClock size={25} /> Ansicht: Zeitverlauf</Button>
                </Col>
            </Row>

            <Row className="mt-5">
                <Col>
                    <ElvDetailsCard 
                        leerstandModal={setLeerstandModal} 
                        teilvorschreibungModal={setTeilvorschreibungModal} 
                        setMissingInvoiceModal={setMissingInvoiceModal}
                        elv={data.elv} 
                        pastElv={data.x_pastelv_id}
                        energyProduct={data.energieprodukt} 
                        tickets={data.tickets}
                    />
                </Col>
            </Row>


            <Row className="mt-5">
                <Col xs="12" md="6" xl="4">
                    <Card style={{borderRadius: "20px", borderBottom: "3px solid #0d6efd", borderLeft: "3px solid #0d6efd"}}>
                        <Card.Body>
                            <Row className="mb-3">
                                <Col xs="3" xl="2" style={{marginLeft: "-10px"}}>
                                    <TbTruckDelivery 
                                        className="text-primary card-icon" 
                                        size={60} 
                                    />
                                </Col>
                                <Col xs="9" xl="10" style={{userSelect: "none"}}>
                                    <h5>Energielieferant</h5>
                                </Col>
                            </Row>
                            <DetailedList key="abrList" data={data.abrechnungen} pdfReader={readPdf} type="abrechnung" />
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs="12" md="6" xl="4">
                    <Card style={{borderRadius: "20px", borderBottom: "3px solid #a2c13f", borderLeft: "3px solid #a2c13f"}}>
                        <Card.Body>
                            <Row className="mb-3">
                                <Col xs="3" xl="2" style={{marginLeft: "-10px"}}>
                                    <FaSwimmingPool 
                                        className="text-energo card-icon" 
                                        size={60} 
                                    />
                                </Col>
                                <Col xs="9" xl="10" style={{userSelect: "none"}}>
                                    <h5>ENERGO</h5>
                                </Col>
                            </Row>
                            <DetailedList key="poolList" data={data.poolrechnungen} pdfReader={readPdf} type="poolrechnung" />
                        </Card.Body>
                    </Card>
                </Col>
                <Col xs="12" md="6" xl="4">
                    <Card style={{borderRadius: "20px", borderBottom: "3px solid #ffc107", borderLeft: "3px solid #ffc107"}}>
                        <Card.Body>
                            <Row className="mb-3">
                                <Col xs="3" xl="2" style={{marginLeft: "-10px"}}>
                                    <TbCoins 
                                        className="text-warning card-icon" 
                                        size={60} 
                                    />
                                </Col>
                                <Col xs="9" xl="10" style={{userSelect: "none"}}>
                                    <h5>Vorschreibungen</h5>
                                </Col>
                            </Row>
                            <DetailedList key="vorList" data={data.vorschreibungen} pdfReader={readPdf} type="vorschreibung" />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <PdfModal show={pdfModal} setShow={setPdfModal} file={pdfFile} />
            <ElvLeerstandModal elv={data.elv} show={leerstandModal} setShow={setLeerstandModal} />
            <ElvTeilVorschreibungModal elv={data.elv} show={teilvorschreibungModal} setShow={setTeilvorschreibungModal} />
            <MissingInvoiceModal elv={data.elv} show={missingInvoiceModal} setShow={setMissingInvoiceModal} />

        </Container>
    )
}

export default ElvDetailPage;